export const LANGUAGE_CONFIG = {
  zh: { name: "中文", locale: "zh-CN", dir: "ltr" },
  en: { name: "English", locale: "en-US", dir: "ltr" },
  es: { name: "Español", locale: "es-ES", dir: "ltr" },
  fr: { name: "Français", locale: "fr-FR", dir: "ltr" },
  de: { name: "Deutsch", locale: "de-DE", dir: "ltr" },
  pt: { name: "Português", locale: "pt-BR", dir: "ltr" },
  ja: { name: "日本語", locale: "ja-JP", dir: "ltr" },
  ko: { name: "한국어", locale: "ko-KR", dir: "ltr" },
  ar: { name: "العربية", locale: "ar", dir: "rtl" },
  hi: { name: "हिन्दी", locale: "hi-IN", dir: "ltr" },
} as const;
export type Language = keyof typeof LANGUAGE_CONFIG;
export const SUPPORTED_LANGUAGES = Object.keys(LANGUAGE_CONFIG) as Language[];
export const resolveLanguage = (value: unknown, fallback: Language = "zh"): Language => {
  if (typeof value !== "string") return fallback;
  const base = value.trim().toLowerCase().replaceAll("_", "-").split(/[-,;]/)[0];
  return Object.hasOwn(LANGUAGE_CONFIG, base) ? base as Language : fallback;
};
export const localeFor = (language: Language): string => LANGUAGE_CONFIG[language].locale;
export const directionFor = (language: Language): "ltr" | "rtl" => LANGUAGE_CONFIG[language].dir;
